<template>
    <div id="ServicePlan">
        <p class="log-title">维保计划</p>
        <div class="list-box">
            <header class="tabs-box clearfix">
                <div :class="{'active':state==0}" @click="headClick(0)" id="headClick0"><span>维保记录</span></div>
                <div :class="{'active':state==1}" @click="headClick(1)" id="headClick1"><span>计划列表</span></div>
            </header>
            <div class="bg">
                <!-- 维保记录 -->
                <div v-show="state == 0" style="height: 95%;">
                    <header class="clearfix top-20 w-97">
                        <el-button type="primary" class="add-btn" @click="addRecord" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">新建维保记录</el-button>
                        <div class="search-box f-r" v-show="state==0">
                            <div class="time-box f-l">
                                <span>时间：</span>
                                <el-date-picker
                                    v-model="beginDate"
                                    :editable="false"
                                    type="date"
                                    class="time m-r-12"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptionsStart"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                                <span>至</span>
                                <el-date-picker
                                    v-model="endDate"
                                    :editable="false"
                                    type="date"
                                    class="time"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptionsEnd"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                                <div class="search w-386 f-l">
                                    <el-input
                                        placeholder="请输入姓名、内容或关联设备"
                                        v-model="searchVal" class="search-input" @keyup.enter.native="search">
                                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                                    </el-input>
                                </div>
                            </div>
                            <div class="f-r">
                                <div class="w-76 f-r">
                                    <el-button type="primary" class="add-btn" @click="search">搜索</el-button>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="clearfix m-t-38" style="height: 95%;">
                        <ul class="list-title" style="width: 100%; margin-left: 0;">
                            <li class="w-18">姓名</li>
                            <li>时间</li>
                            <li class="w-18">维保内容</li>
                            <li class="w-18">关联设备</li>
                            <li>操作</li>
                        </ul>
                        <div class="scroll w-100 m-t-0">
                            <ul class="list-details" v-for="(item,i) in recordList" :key="i">
                                <li :title="item.userName" class="w-18">{{item.userName}}</li>
                                <li :title="changeTime(item.operateTime)">{{changeTime(item.operateTime)}}</li>
                                <li :title="item.context" class="w-18">{{item.context}}</li>
                                <li :title="item.deviceNameSet" class="w-18">{{item.deviceNameSet}}</li>
                                <li class="operate">
                                    <span @click="open(i,'delRecordShow',item)" :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}">删除</span>
                                </li>
                            </ul>
                        </div>
                        <div style=" margin-top: 32px;"><Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber" v-show="state==0"></Pagination></div>
                        <!-- 没有列表数据 -->
                        <div class="nullDataBox" v-show="recordList.length==0">
                            <img :src="nullData" class="nullData">
                            <span>什么东西都没有找到...</span>
                        </div>
                    </div>
                </div>
                <!-- 计划列表 -->
                <div v-show="state == 1" style="height: 95%;">
                    <header class="clearfix top-20">
                        <el-button type="primary" class="add-btn" @click="addPlan" :disabled="!$store.state.functionList.includes('companyServiceContrl')||$store.state.isLook">新建维保计划</el-button>
                    </header>
                    <div class="clearfix m-t-38" style="height: 100%;">
                        <ul class="list-title" style="width: 100%; margin-left: 0;">
                            <li class="w-18">计划名称</li>
                            <li>维保条件</li>
                            <li>计划状态</li>
                            <li>维保状态</li>
                            <li class="w-18">维保内容</li>
                            <li class="w-18">操作</li>
                        </ul>
                        <div class="scroll" v-show="planList.length!=0">
                            <ul class="list-details" v-for="(item,i) in planList" :key="i">
                                <li :title="item.name" class="w-18">{{item.name}}</li>
                                <li>{{item.conditionType ==1?"设备属性":"时间"}}</li>
                                <li :class="{'color-red':item.state != 1}">{{item.state==1?"启用":item.state==2?"停用":"已过期"}}</li>
                                <li>{{item.serviceState==1?"无需维保":"待维保"}}</li>
                                <li :title="item.note" class="w-18">{{item.note}}</li>
                                <li class="operate w-18">
                                    <span @click="open(i,'editPlanShow',item)">{{$store.state.functionList.includes('companyServiceEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" v-show="item.state != 1" @click="open(i,'enablePlanShow',item)">启用</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" v-show="item.state == 1" @click="open(i,'disPlanShow',item)">停用</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" @click="open(i,'delPlanShow',item)">删除</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceContrl')||$store.state.isLook}" @click="open(i,'resetShow',item)">复位</span>
                                </li>
                            </ul>
                        </div>
                        <!-- 没有列表数据 -->
                        <div class="nullDataBox" v-show="planList.length==0">
                            <img :src="nullData" class="nullData">
                            <span>什么东西都没有找到...</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 分页 -->
            <!-- <div style="position: absolute; bottom: 68px; width: 100%;"></div><Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber" v-show="state==0"></Pagination></div> -->
            <!-- 弹窗 -->
            <div class="popup">
                <!-- 删除维保计划 -->
                <div class="popup-delAlarm" v-show="delPlanShow">
                    <div class="popup-title">
                        删除维保计划<i class="el-icon-circle-close close" @click="close('delPlanShow')" id="closeDel1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将删除该维保计划"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="delPlayAlarm" id="delAlarm">确定</el-button> <el-button @click="close('delPlanShow')" id="closeDel2">取消</el-button></p>
                    </div>
                </div>
                <!-- 删除维保记录 -->
                <div class="popup-delAlarm" v-show="delRecordShow">
                    <div class="popup-title">
                        删除维保记录<i class="el-icon-circle-close close" @click="close('delRecordShow')" id="closeDel3"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将删除该维保记录"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="delRecordAlarm" id="delAlarm">确定</el-button> <el-button @click="close('delRecordShow')" id="closeDel4">取消</el-button></p>
                    </div>
                </div>
                <!-- 启用维保计划 -->
                <div class="popup-delAlarm" v-show="enablePlanShow">
                    <div class="popup-title">
                        启用维保计划<i class="el-icon-circle-close close" @click="close('enablePlanShow')" id="closeDel5"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将启用该维保计划"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="enablePlan" id="delAlarm">确定</el-button> <el-button @click="close('enablePlanShow')" id="closeDel6">取消</el-button></p>
                    </div>
                </div>
                <!-- 停用维保计划 -->
                <div class="popup-delAlarm" v-show="disPlanShow">
                    <div class="popup-title">
                        停用维保计划<i class="el-icon-circle-close close" @click="close('disPlanShow')" id="closeDel7"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将停用该维保计划"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="disPlan" id="delAlarm">确定</el-button> <el-button @click="close('disPlanShow')" id="closeDel8">取消</el-button></p>
                    </div>
                </div>
                <!-- 复位维保计划 -->
                <div class="popup-delAlarm" v-show="resetShow">
                    <div class="popup-title">
                        复位维保计划<i class="el-icon-circle-close close" @click="close('resetShow')" id="closeDis1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将复位该维保计划"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" id="disAlarm" @click="resetAlarm">确定</el-button> <el-button @click="close('resetShow')" id="closeDis2">取消</el-button></p>
                    </div>
                </div>
                <!-- 新建维保记录 -->
                <div class="popup-addRecord" v-show="addRecordShow">
                    <div class="popup-title">
                        新建维保记录<i class="el-icon-circle-close close" @click="close('addRecordShow')"></i>
                    </div>
                    <div class="popup-lab">
                        <el-form :model='ruleForm' :rules="rules" ref="addRecord" class="clearfix" :disabled="!$store.state.functionList.includes('companyServiceEdit')">
                            <el-form-item prop="name" label="姓名：" autocomplete="off" class="no-title">
                                <i><img :src="notes" title="姓名支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.name" disabled>{{ruleForm.name}}</el-input>
                            </el-form-item>
                            <p class="m-t-15">关联设备：<span :title="devNameList.toString()" class="dev-name-list">{{devNameList.length==0?'无':devNameList.toString()}}</span></p>
                            <p class="invented-btn m-b-12" @click="selectDevShow=true">选择关联设备</p>
                            <el-form-item label="维保内容：" prop="note">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks note"
                                    v-model="ruleForm.note"
                                    maxlength="255"
                                    show-word-limit
                                    id="editRemarks"
                                    placeholder="请输入描述">
                                </el-input>
                            </el-form-item>
                            <p class="btn-box b-32"><el-button type="primary" @click="createdRecord">确定</el-button> <el-button @click="close('addRecordShow')">取消</el-button></p>
                        </el-form>
                    </div>
                </div>
                <!-- 选择设备 -->
                <div class="popup-select-attribute" v-show="selectDevShow" style="z-index: 1001 !important;">
                    <div class="popup-title no-border">
                        选择设备<i class="el-icon-circle-close close" @click="close('selectDevShow')"></i>
                    </div>
                    <div class="option-box">
                            <p class="option-box-top">设备名称<el-checkbox class="all-check" :indeterminate="isIndeterminate" v-model="checkAll" @change="devAllChange">全选</el-checkbox></p><!--  -->
                            <div class="option-scorll-box">
                                <el-checkbox-group v-model="ruleForm.devIdList" @change="devCheckedChange">
                                    <el-checkbox v-for="dev in deviceList" :label="dev.id" :key="dev.id">{{dev.name}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" @click="addDev">确定</el-button> <el-button @click="close('selectDevShow')">取消</el-button></p>
                </div>
                <!-- 新建维保计划 -->
                <div class="popup-addRecord" v-show="addPlanShow">
                    <div class="popup-title">
                        新建维保计划<i class="el-icon-circle-close close" @click="close('addPlanShow')"></i>
                    </div>
                    <div class="popup-lab">
                        <el-form :model='ruleForm' :rules="rules" ref="addPlan" class="clearfix" :disabled="!$store.state.functionList.includes('companyServiceEdit')">
                            <el-form-item prop="RecordName" label="计划名称：" autocomplete="off" class="no-title">
                                <i><img :src="notes" title="计划名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.RecordName"></el-input>
                            </el-form-item>
                            <el-form-item label="维保条件：" autocomplete="off" class="no-title" >
                                <el-select v-model="ruleForm.conditionType" placeholder="请选择" class="w-100">
                                    <el-option :value=1 label="设备属性"></el-option>
                                    <el-option :value=2 label="时间"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item class="dev-attr-box" v-show="ruleForm.conditionType==1">
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.deviceCode`" :rules="rules.trigger_deviceCode">
                                    <el-select v-model="ruleForm.trigger.deviceCode" :title="ruleForm.trigger.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(ruleForm.trigger.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev">
                                        <el-option
                                        :key="VirtualDevice.id"
                                        label="虚拟设备"
                                        :value="VirtualDevice.code" >
                                        </el-option>
                                        <el-option
                                        v-for="devObj in deviceList"
                                        :key="devObj.id"
                                        :label="devObj.name"
                                        :value="devObj.code" >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.property`" :rules="rules.trigger_property">
                                    <el-select v-model="ruleForm.trigger.property" :title="getTitle(ruleForm.trigger.property,ruleForm.trigger.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr">
                                        <el-option
                                        v-for="attrObj in ruleForm.trigger.propertyData"
                                        :key="attrObj.identifier"
                                        :label="attrObj.name"
                                        :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.compare`" :rules="rules.trigger_compare">
                                    <el-select v-model="ruleForm.trigger.compare" placeholder="请选择" @change="changeCompare" class="attribute w-75" v-show="ruleForm.trigger.type == 'int' || ruleForm.trigger.type == 'float' || ruleForm.trigger.type == 'double'">
                                        <el-option :value=1 label=">"></el-option>
                                        <el-option :value=2 label=">="></el-option>
                                        <el-option :value=3 label="=="></el-option>
                                        <el-option :value=4 label="<"></el-option>
                                        <el-option :value=5 label="<="></el-option>
                                        <el-option :value=6 label="!="></el-option>
                                        <el-option :value=7 label="in"></el-option>
                                        <el-option :value=8 label="between"></el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.trigger.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.trigger.type == 'bool' || ruleForm.trigger.type == 'enum'">
                                        <el-option :value=3 label="=="></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.value`" :rules="rules.trigger_value">
                                    <el-input class="attribute f-r m-r-0" placeholder="请输入比较值" @input="regNumber('value')" v-model="ruleForm.trigger.value" v-show="ruleForm.trigger.type == 'int' || ruleForm.trigger.type == 'float' || ruleForm.trigger.type == 'double'"></el-input>
                                    <el-select v-model="ruleForm.trigger.value" placeholder="请选择" class="attribute f-r m-r-0" v-show="ruleForm.trigger.type == 'bool' || ruleForm.trigger.type == 'enum'">
                                        <el-option
                                        v-for="specsObj in ruleForm.trigger.propertyData.specs"
                                        :key="specsObj.key"
                                        :label="specsObj.value"
                                        :value="specsObj.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form-item>
                            <el-form-item v-show="ruleForm.conditionType==2" prop="timeType">
                                <p>
                                    <el-radio-group v-model="radioTime">
                                        <el-radio :label="1">指定时间</el-radio>
                                        <el-radio :label="2">特定时间</el-radio>
                                    </el-radio-group>
                                </p>
                                <div v-show='radioTime == 1'>
                                    <el-date-picker
                                        v-model="ruleForm.assignDate"
                                        type="datetime"
                                        class="w-100 assignDate"
                                        placeholder="选择日期"
                                        :disabled='radioTime == 2'
                                        :clearable='false'
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :editable='false'
                                        id="addAssignDate"
                                        :picker-options="pickerOptionsOver"
                                        @change="changeAssign"
                                    >
                                    </el-date-picker>
                                </div>
                                <div v-show="radioTime == 2">
                                    <el-checkbox-group v-model="ruleForm.weekList" class="weekList">
                                        <el-checkbox :label="2">周一</el-checkbox>
                                        <el-checkbox :label="3">周二</el-checkbox>
                                        <el-checkbox :label="4">周三</el-checkbox>
                                        <el-checkbox :label="5">周四</el-checkbox>
                                        <el-checkbox :label="6">周五</el-checkbox>
                                        <el-checkbox :label="7">周六</el-checkbox>
                                        <el-checkbox :label="1">周日</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                            <p class="m-t-26" v-show="radioTime==2 &&ruleForm.conditionType==2">
                                <span>时：</span>
                                <el-select v-model="ruleForm.hour" placeholder="请选择" class="attribute">
                                    <el-option v-for="hour in hourData" :key="hour" :value="hour" :label="hour"></el-option>
                                </el-select>
                                <span>分：</span>
                                <el-select v-model="ruleForm.min" placeholder="请选择" class="attribute">
                                    <el-option v-for="min in MinuteSecond" :key="min" :value="min" :label="min"></el-option>
                                </el-select>
                                <span>秒：</span>
                                <el-select v-model="ruleForm.second" placeholder="请选择" class="attribute">
                                    <el-option v-for="second in MinuteSecond" :key="second" :value="second" :label="second"></el-option>
                                </el-select>
                            </p>
                            <el-form-item label="维保内容：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="255"
                                    show-word-limit
                                    id="addRemarks"
                                    placeholder="请输入描述">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" @click="createdPlan">确定</el-button> <el-button @click="close('addPlanShow')">取消</el-button></p>
                </div>
                <!-- 编辑维保计划 -->
                <div class="popup-addRecord" v-show="editPlanShow">
                    <div class="popup-title">
                        {{$store.state.functionList.includes('companyServiceEdit')&&!$store.state.isLook?'编辑':'查看'}}维保计划<i class="el-icon-circle-close close" @click="close('editPlanShow')" ></i>
                    </div>
                    <div class="popup-lab">
                        <el-form :model='ruleForm' :rules="rules" ref="editPlan" class="clearfix" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">
                            <el-form-item prop="RecordName" label="计划名称：" autocomplete="off" class="no-title">
                                <i><img :src="notes" title="计划名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.RecordName"></el-input>
                            </el-form-item>
                            <el-form-item label="维保条件：" autocomplete="off" class="no-title" >
                                <el-select v-model="ruleForm.conditionType" placeholder="请选择" class="w-100">
                                    <el-option :value=1 label="设备属性"></el-option>
                                    <el-option :value=2 label="时间"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item class="dev-attr-box" v-show="ruleForm.conditionType==1">
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.deviceCode`" :rules="rules.trigger_deviceCode">
                                    <el-select v-model="ruleForm.trigger.deviceCode" :title="ruleForm.trigger.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(ruleForm.trigger.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev">
                                        <el-option
                                        :key="VirtualDevice.id"
                                        label="虚拟设备"
                                        :value="VirtualDevice.code" >
                                        </el-option>
                                        <el-option
                                        v-for="devObj in deviceList"
                                        :key="devObj.id"
                                        :label="devObj.name"
                                        :value="devObj.code" >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.property`" :rules="rules.trigger_property">
                                    <el-select v-model="ruleForm.trigger.property" :title="getTitle(ruleForm.trigger.property,ruleForm.trigger.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr">
                                        <el-option
                                        v-for="attrObj in ruleForm.trigger.propertyData"
                                        :key="attrObj.identifier"
                                        :label="attrObj.name"
                                        :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.compare`" :rules="rules.trigger_compare">
                                    <el-select v-model="ruleForm.trigger.compare" placeholder="请选择" @change="changeCompare" class="attribute w-75" v-show="ruleForm.trigger.type == 'int' || ruleForm.trigger.type == 'float' || ruleForm.trigger.type == 'double'">
                                        <el-option :value=1 label=">"></el-option>
                                        <el-option :value=2 label=">="></el-option>
                                        <el-option :value=3 label="=="></el-option>
                                        <el-option :value=4 label="<"></el-option>
                                        <el-option :value=5 label="<="></el-option>
                                        <el-option :value=6 label="!="></el-option>
                                        <el-option :value=7 label="in"></el-option>
                                        <el-option :value=8 label="between"></el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.trigger.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.trigger.type == 'bool' || ruleForm.trigger.type == 'enum'">
                                        <el-option :value=3 label="=="></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.value`" :rules="rules.trigger_value">
                                    <el-input class="attribute f-r m-r-0" placeholder="请输入比较值" @input="regNumber('value')" v-model="ruleForm.trigger.value" v-show="ruleForm.trigger.type == 'int' || ruleForm.trigger.type == 'float' || ruleForm.trigger.type == 'double'"></el-input>
                                    <el-select v-model="ruleForm.trigger.value" placeholder="请选择" class="attribute f-r m-r-0" v-show="ruleForm.trigger.type == 'bool' || ruleForm.trigger.type == 'enum'">
                                        <el-option
                                        v-for="specsObj in ruleForm.trigger.propertyData.specs"
                                        :key="specsObj.key"
                                        :label="specsObj.value"
                                        :value="specsObj.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form-item>
                            <el-form-item v-show="ruleForm.conditionType==2" prop="timeType">
                                <p>
                                    <el-radio-group v-model="radioTime">
                                        <el-radio :label="1">指定时间</el-radio>
                                        <el-radio :label="2">特定时间</el-radio>
                                    </el-radio-group>
                                </p>
                                <div v-show='radioTime == 1'>
                                    <el-date-picker
                                        v-model="ruleForm.assignDate"
                                        type="datetime"
                                        class="w-100 assignDate"
                                        placeholder="选择日期"
                                        :disabled='radioTime == 2'
                                        :clearable='false'
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :picker-options="pickerOptionsOver"
                                        :editable='false'
                                        id="editAssignDate"
                                    >
                                    </el-date-picker>
                                </div>
                                <el-checkbox-group v-model="ruleForm.weekList" class="weekList" v-show='radioTime == 2'>
                                    <el-checkbox :label="2" :disabled='radioTime == 1'>周一</el-checkbox>
                                    <el-checkbox :label="3" :disabled='radioTime == 1'>周二</el-checkbox>
                                    <el-checkbox :label="4" :disabled='radioTime == 1'>周三</el-checkbox>
                                    <el-checkbox :label="5" :disabled='radioTime == 1'>周四</el-checkbox>
                                    <el-checkbox :label="6" :disabled='radioTime == 1'>周五</el-checkbox>
                                    <el-checkbox :label="7" :disabled='radioTime == 1'>周六</el-checkbox>
                                    <el-checkbox :label="1" :disabled='radioTime == 1'>周日</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <p v-show='radioTime == 2&&ruleForm.conditionType==2' class="m-t-26">
                                <span>时：</span>
                                <el-select v-model="ruleForm.hour" placeholder="请选择" class="attribute" :disabled='radioTime == 1'>
                                    <el-option v-for="hour in hourData" :key="hour" :value="hour" :label="hour"></el-option>
                                </el-select>
                                <span>分：</span>
                                <el-select v-model="ruleForm.min" placeholder="请选择" class="attribute" :disabled='radioTime == 1'>
                                    <el-option v-for="min in MinuteSecond" :key="min" :value="min" :label="min"></el-option>
                                </el-select>
                                <span>秒：</span>
                                <el-select v-model="ruleForm.second" placeholder="请选择" class="attribute" :disabled='radioTime == 1'>
                                    <el-option v-for="second in MinuteSecond" :key="second" :value="second" :label="second"></el-option>
                                </el-select>
                            </p>
                            <el-form-item label="维保内容：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="255"
                                    show-word-limit
                                    id="editRemarks2"
                                    placeholder="请输入描述">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" @click="updatePlan('editPlan')" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">确定</el-button> <el-button @click="close('editPlanShow')">取消</el-button></p>
                </div>

                <!-- 验证码授权 -->
                <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -216px; z-index:1000 !important;">
                    <div class="popup-title">
                        获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                    </div>
                    <div class="popup-lab">
                        手机号：
                        <el-input disabled v-model="phone">{{phone}}</el-input>
                    </div>
                    <div class="popup-lab clearfix">
                        <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                        <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                            <el-form-item prop="verifyCode">
                                <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="code-box">
                            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                        </div>
                    </div>
                    <div class="popup-lab">
                        <p class="btn-box" style="margin-top: 26px;">
                            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                            <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                        </p>
                    </div>
                </div>

            </div>
        </div>
        <!-- <div style="position: fixed; z-index: 1000; background-color:rgba(0, 0, 0, .4);left: 0; right: 0; top: 0; bottom: 0;" v-show="selectDevShow"></div> -->
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
export default {
    data() {
        var valiWarnName = (rule, value, callback) =>{  //计划
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入计划名称不能为空'));
            }else if(value.length>32){
                callback(new Error('计划名称由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var valiName = (rule, value, callback) =>{  //规则名称
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入姓名'));
            }else if(value.length>32){
                callback(new Error('姓名由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var valiType= (rule, value, callback) =>{      //通知时段
            // console.log(this.radioTime)
            if(this.ruleForm.conditionType==2){
                if(this.radioTime== 2 && this.ruleForm.weekList.length == 0){
                    callback(new Error('请选择通知时段具体周'));
                }else if(this.radioTime== 1 && (this.ruleForm.assignDate == null||this.ruleForm.assignDate == '')){
                    callback(new Error('请选择指定时间'));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        }
        var valiDevice= (rule, value, callback) =>{
            if(this.ruleForm.conditionType==1){      //shebei
                if(this.ruleForm.trigger.deviceCode==null){
                    callback(new Error('请选择设备'));
                }else if(this.ruleForm.trigger.property==null){
                    callback(new Error('请选择设备属性'));
                }else if(this.ruleForm.trigger.compare==null){
                    callback(new Error('请选择比较模式'));
                }else if(this.ruleForm.trigger.value==null||this.ruleForm.trigger.value==''){
                    callback(new Error('比较值不能为空'));
                }else {
                    callback()
                    // console.log(111)
                }
            }else{
                callback();
            }
        }
        var valiDeviceCode= (rule, value, callback) =>{
            if(this.ruleForm.conditionType==1){      //shebei
                if(this.ruleForm.trigger.deviceCode==null){
                    callback(new Error('请选择设备'));
                }{
                    callback()
                }
            }else{
                callback();
            }
        }
        var valiProperty= (rule, value, callback) =>{
            if(this.ruleForm.conditionType==1){      //shebei
                if(this.ruleForm.trigger.property==null){
                    callback(new Error('请选择属性'));
                }{
                    callback()
                }
            }else{
                callback();
            }
        }
        var valiCompare= (rule, value, callback) =>{
            if(this.ruleForm.conditionType==1){      //shebei
                if(this.ruleForm.trigger.compare==null){
                    callback(new Error('请选择比较模式'));
                }{
                    callback()
                }
            }else{
                callback();
            }
        }
        var valiValue= (rule, value, callback) =>{
            if(this.ruleForm.conditionType==1){      //shebei
                if(this.ruleForm.trigger.value==null||this.ruleForm.trigger.value==''){
                    callback(new Error('比较值不能为空'));
                }{
                    callback()
                }
            }else{
                callback();
            }
        }
        return {
            state:0,
            totalCount:0,
            pageSize:0,
            pageNumber:1,
            editShow:false,
            delPlanShow:false,
            delRecordShow:false,
            resetShow:false,
            addPlanShow:false,
            editPlanShow:false,
            addRecordShow:false,
            enablePlanShow:false,
            disPlanShow:false,
            selectDevShow:false,
            isIndeterminate: false,
            checkAll: false,
            radioTime:1,
            notes:require('@/assets/image/organize/notes.png'),
            nullData:require('@/assets/image/index/nullData.png'),
            planList:[],    //维保计划列表
            recordList:[],  //维保记录列表
            deviceList:[],
            allDev:[],
            VirtualDevice:{},   //虚拟设备
            VirtualFuncList:[], //虚拟设备属性列表
            // allProductData:[],
            nowIndex:null,
            nowObj:{},
            hourData:[],
            beginDate:null,
            endDate:null,
            searchVal:null,
            MinuteSecond:[],
            ruleForm:{
                name:"",
                RecordName:null,
                note:"",
                devIdList:[],
                state:1,
                conditionType:1,
                trigger:{
                    deviceCode:null,
                    property:null,
                    compare:null,
                    value:null,
                    type:'int',
                    propertyData:[
                        {dataType:{type:'int'}}
                    ]
                },
                assignDate:"",
                weekList:[],
                hour:"00",
                min:"00",
                second:"00",
            },
            rules:{
                name:[{required: true, validator: valiName, trigger: 'blur' }],
                RecordName:[{required:true,validator: valiWarnName,trigger:"blur"}],
                timeType:[{validator: valiType, required: true, trigger:'change'}],
                device:[{required:true,validator: valiDevice,trigger:"change"}],
                note:[{required:true,message:'请输入维保内容',trigger:"bulr"}],
                trigger_deviceCode:[{required:true,validator: valiDeviceCode,trigger:"change"}],
                trigger_property:[{required:true,validator: valiProperty,trigger:"change"}],
                trigger_compare:[{required:true,validator: valiCompare,trigger:"change"}],
                trigger_value:[{required:true,validator: valiValue,trigger:"change"}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
            },
            oldDevList:[],
            devNameList:[],
            pickerOptionsOver: {
                disabledDate(date) {
                    return date.getTime() <= Date.now() - 86400000;
                }
            },
            pickerOptionsStart: {
                disabledDate: time => {
                    if (this.endTime) {
                        return time.getTime() > new Date(this.endTime).getTime()
                    }
                }
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    if (this.beginDate) {
                        return time.getTime() < new Date(this.beginDate).getTime() - 86400000
                    }
                }
            },
            functionShow:false,
            VerifyArr:[],
            verifyForm:{
                verifyCode:'',
            },
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
        }
    },
    components:{
        Pagination
    },
    props: {
        companyId:{
            type:Number,
            required:true,
        }
    },
    created() {
        this.$store.state.headerActive=3;
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.getRecord({pageNumber:this.pageNumber,length:this.pageSize,companyId:this.companyId})
        this.getPlan({companyId:this.companyId})
        this.getdeviceList()
        this.changeList()
        this.getVirtualDevice()
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
        this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
    },
    methods: {
        // 获取维保记录
        getRecord(parm){
            this.get('/ServiceLog/query',parm).then((res)=>{
                if(res.success){
                    this.recordList = res.result.data
                    this.totalCount = res.result.totalCount;
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取维保记录失败：${res.message}`
                    })
                }
            })
        },
        // 获取维保计划
        getPlan(parm){
            this.get('/ServicePlan/getList',parm).then((res)=>{
                if(res.success){
                    this.planList = res.result
                }
            })
        },
        // 设置时分秒列表
        changeList(){
            for(let i=0;i<24;i++){
                let hour
                if(i<10){
                    hour = "0"+i
                }else{
                    hour = i.toString()
                }
                this.hourData.push(hour)
            }
            for(let i=0;i<60;i++){
                let MS
                if(i<10){
                    MS = "0"+i
                }else{
                    MS = i.toString()
                }
                this.MinuteSecond.push(MS)
            }
        },
        //获取指定企业的虚拟设备
        getVirtualDevice(){
            let parm = {companyId:this.companyId}
            this.get('/VirtualDevice/get',parm).then((res)=>{
                if(res.success){
                    this.VirtualDevice = res.result
					this.getVirtualFuncList()
                }
            })
        },
        //获取虚拟设备的属性列表
        getVirtualFuncList(){
			if(!this.VirtualDevice.id&&this.VirtualDevice.id!=0){ return }
            let parm = {deviceId:this.VirtualDevice.id,companyId:this.companyId}
            this.get('/VirtualDevice/getPropertyList',parm).then((res)=>{
                if(res.success){
                    for(let obj of res.result){
                        obj.dataType={type:'double',specs:[]}
                        obj.identifier = obj.code
                    }
                    this.VirtualFuncList = res.result
                }
            })
        },
        // //获取所有产品
        // getProlist(){
        //     this.get('/Product/getList',{companyId:this.companyId}).then((res)=>{
        //         if(res.success){
        //             this.allProductData=res.result;
        //         }else{
        //             this.$message({
        //                 message: `获取产品数据失败：${res.message}`,
        //                 type: 'warning'
        //             });
        //         }
        //     })
        // },
        //获取设备列表
        getdeviceList(){
            let parm = {companyId:this.companyId}
            this.get('/Device/getList',parm).then((res)=>{
                if(res.success){
                    this.deviceList = res.result
                    for(let dev of this.deviceList){
                        //将所有设备的id取出
                        this.allDev.push(dev.id)
                    }
                }else{
                    this.$message({
                        message: `获取设备数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 头部点击
        headClick(i){
            this.state = i
            if(i == 0){
                this.getRecord({pageNumber:this.pageNumber,length:this.pageSize,companyId:this.companyId})
            }else{
                this.getPlan({companyId:this.companyId})
            }
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            let parm ={
                companyId:this.companyId,
                length:this.pageSize,
                pageNumber:this.pageNumber,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
            }
            this.getRecord(parm)
        },
        // 修改页数
        setNum(number){
            this.pageNumber=number;
            let parm ={
                companyId:this.companyId,
                length:this.pageSize,
                pageNumber:this.pageNumber,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
            }
            this.getRecord(parm)
        },
        //设备变更时更新对应属性值
        changeDev(code,setAttr){
            if(code==this.VirtualDevice.code){
                this.ruleForm.trigger.propertyData = this.VirtualFuncList
                if(setAttr){
                    this.ruleForm.trigger.property = this.nowObj.conditions.property
                    this.changeAttr(this.ruleForm.trigger.property)
                    this.ruleForm.trigger.compare = this.nowObj.conditions.compare
                    this.ruleForm.trigger.value = this.nowObj.conditions.value
                }
                return
            }
            let attrData = null
            this.get('/ProductFeature/getByDeviceCode',{code:code}).then((res)=>{
                if(res.success){
                    let attrData=JSON.parse(res.result).properties   //属性数组
                    let propertyArr;  //设备关联属性数组
                    for(let devObj of this.deviceList){
                        if(devObj.code == code){
                            propertyArr = devObj.propertySet.split(',')  //设备关联属性数组
                        }
                    }
                    let arr = []
                    for(let attrObj of attrData){
                        for(let property of propertyArr){
                            if(property==attrObj.identifier){
                                arr.push(attrObj)
                            }
                        }
                    }
                    this.ruleForm.trigger.propertyData=arr
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取设备属性失败：${res.message}`
                    })
                }
            }).then(()=>{
                if(setAttr){
                    this.ruleForm.trigger.property = this.nowObj.conditions.property
                    this.changeAttr(this.ruleForm.trigger.property)
                    this.ruleForm.trigger.compare = this.nowObj.conditions.compare
                    this.ruleForm.trigger.value = this.nowObj.conditions.value
                }
            })
        },
        //设备属性变更时改变对应比较值
        changeAttr(val){
            this.ruleForm.trigger.compare=null;
            this.ruleForm.trigger.value=null;
            // console.log(this.ruleForm.trigger.propertyData)
            for(var obj of this.ruleForm.trigger.propertyData){
                if(val == obj.identifier){
                    this.ruleForm.trigger.type=obj.dataType.type
                    if(obj.dataType.type=="bool"||obj.dataType.type=="enum"){
                        let arr = [];
                        var that = this;
                        Object.keys(obj.dataType.specs).forEach(function(key){
                            let item ={};
                            item.key = key;
                            item.value = obj.dataType.specs[key]
                            arr.push(item);
                        });
                        that.ruleForm.trigger.propertyData.specs=arr;
                    }
                }
            }
        },
        // 打开弹窗
        open(i,name,obj){
            this.nowIndex= i;
            if(name=="editPlanShow"){
                let parm={
                    id:obj.id,
                    companyId:this.companyId
                }
                this.get('/ServicePlan/get',parm).then((res)=>{
                    if(res.success){
                        this.nowObj = res.result
                        this.nowObj.conditions = JSON.parse(this.nowObj.conditions)
                        this.ruleForm.RecordName= this.nowObj.name;
                        this.ruleForm.note = this.nowObj.note;
                        this.ruleForm.state = this.nowObj.state;
                        this.ruleForm.conditionType = this.nowObj.conditionType;
                        if(this.nowObj.conditionType == 2){   //时间
                            this.radioTime = this.nowObj.conditions.type
                            if(this.radioTime == 2){
                                this.ruleForm.weekList = this.nowObj.conditions.week;
                                let time = this.nowObj.conditions.time;
                                let h=Math.floor(time/3600);
                                let m=Math.floor((time - h*3600)/60);
                                let s=time - h*3600 - m*60
                                if(h<10){
                                    h="0"+h
                                }else{
                                    h=h.toString()
                                }
                                if(m<10){
                                    m="0"+m
                                }else{
                                    m=m.toString()
                                }
                                if(s<10){
                                    s="0"+s
                                }else{
                                    s=s.toString()
                                }
                                this.ruleForm.hour = h
                                this.ruleForm.min = m
                                this.ruleForm.second = s
                            }else{
                                this.ruleForm.assignDate = this.changeTime(Number(this.nowObj.conditions.date))
                            }
                        }else{
                            this.ruleForm.trigger.deviceCode = this.nowObj.conditions.deviceCode
                            this.changeDev(this.ruleForm.trigger.deviceCode,true)
                        }
                        this.$refs.editPlan.clearValidate()
                        this[name]=true;
                        this.$store.state.mask=true;
                    }else{
                        this.$message({
                            message: `获取维保计划失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                })
                return
            }else if(name=='resetShow'&&this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceEdit')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }else if(!this.$store.state.functionList.includes('companyServiceEdit')||this.$store.state.isLook||name=='resetShow'&&!this.$store.state.functionList.includes('companyServiceContrl')){
                return
            }
            this.nowObj = obj
            this[name]=true;
            this.$store.state.mask=true;
        },
        addPlan(){
            if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceContrl')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }else{

            }
            this.ruleForm = this.$options.data().ruleForm
            this.addPlanShow = true
            this.$store.state.mask = true
            this.$refs.addPlan.clearValidate()
        },
        // 确定选择关联设备
        addDev(){
            this.selectDevShow = false
            this.oldDevList = this.clone(this.ruleForm.devIdList)
            this.devNameList = [];
            for(let obj of this.deviceList){
                for(let id of this.ruleForm.devIdList){
                    if(obj.id == id){
                        this.devNameList.push(obj.name)
                    }
                }
            }
        },
        // 关闭弹窗
        close(name){
            this[name]=false;
            if(name=="selectDevShow"){
                this.ruleForm.devIdList = this.oldDevList
                return
            }
            this.$store.state.mask=false;
            this.ruleForm = this.$options.data().ruleForm;
        },
        //输入框格式
        regNumber(regObj){
            if(this.ruleForm.trigger.compare==7||this.ruleForm.trigger.compare==8){
                this.ruleForm.trigger[regObj] = '['+this.ruleForm.trigger[regObj].replace(/[^\-?\d.,]/g,"").replace(/\[/g, "").replace(/\]/g, "").replace(/,,/g, ",")+']';
            }else{
                this.ruleForm.trigger[regObj] = this.ruleForm.trigger[regObj].replace(/[^\-?\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g,"");
            }
        },
        // 删除维保计划
        delPlayAlarm(){
            let parm = {id:this.nowObj.id,companyId:this.companyId}
            this.get('/ServicePlan/remove',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除维保计划成功',
                        type: 'success'
                    });
                    this.getPlan({companyId:this.companyId})
                }else{
                    this.$message({
                        message: `删除维保计划失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.delPlanShow=false
            })
        },
        // 删除维保记录
        delRecordAlarm(id){
            let parm = {
                id:this.nowObj.id,
                requestId:1,
                companyId:this.companyId
            }
            this.get('/ServiceLog/remove',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除维保记录成功',
                        type: 'success'
                    });
                    this.search()
                }else{
                    this.$message({
                        message: `删除维保记录失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
            this.$store.state.mask=false;
            this.delRecordShow=false
        },
        // 复位维保计划
        resetAlarm(){
            let parm = {id:this.nowObj.id,companyId:this.companyId}
            this.get('/ServicePlan/reset',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '复位维保计划成功',
                        type: 'success'
                    });
                    this.get('/ServicePlan/get',parm).then((res)=>{
                        if(res.success){
                            this.planList[this.nowIndex]=res.result
                            this.$forceUpdate()
                        }
                    })
                }else{
                    this.$message({
                        message: `复位维保计划失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.resetShow=false
            })
        },
        // 启用维保计划
        enablePlan(){
            let parm = {id:this.nowObj.id,companyId:this.companyId}
            this.get('/ServicePlan/enable',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '启用维保计划成功',
                        type: 'success'
                    });
                    this.planList[this.nowIndex].state=1
                }else{
                    this.$message({
                        message: `启用维保计划失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.enablePlanShow=false
            })
        },
        //停用维保计划
        disPlan(){
            let parm = {id:this.nowObj.id,companyId:this.companyId}
            this.get('/ServicePlan/disable',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '停用维保计划成功',
                        type: 'success'
                    });
                    this.planList[this.nowIndex].state=2
                }else{
                    this.$message({
                        message: `停用维保计划失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.disPlanShow=false
            })
        },
        //全选设备
        devAllChange(val) {
            this.ruleForm.devIdList = val ? this.allDev : [];
            this.isIndeterminate = false;
        },
        //所选属性变化
        devCheckedChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.allDev.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.allDev.length;
        },
        // 搜索
        search(){
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                companyId:this.companyId,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.searchVal,
            }
            this.getRecord(parm)
        },
        // 新建维保记录弹窗
        addRecord(){
            this.ruleForm.name=this.$store.state.userData.displayName
            this.$store.state.mask=true;
            this.addRecordShow=true;
        },
        // 新建维保记录
        createdRecord(){
            this.$refs.addRecord.validate((valid) => {
                if(valid){
                    let parm = {
                        userName:this.ruleForm.name,
                        companyId:this.companyId,
                        context:this.ruleForm.note,
                        deviceSet:this.ruleForm.devIdList.toString(),
                        deviceNameSet:this.devNameList.toString(),
                    }
                    this.post('/ServiceLog/create',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '新建记录成功',
                                type: 'success'
                            });
                            this.search()
                        }else{
                            this.$message({
                                message: `新建记录失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                        this.$store.state.mask = false;
                        this.addRecordShow = false;
                        this.ruleForm=this.$options.data().ruleForm;
                        this.devNameList = [];
                        this.checkAll=false;
                    })
                }
            })
        },
        changeCompare(i){
            if(i==7||i==8){
                this.ruleForm.trigger.value="";
            }
        },
        //新建维保计划
        createdPlan(){
            this.$refs.addPlan.validate((valid) => {
                // console.log(valid)
                if(valid){
                    let parm = {
                        companyId:this.companyId,
                        requestId:1,
                        name:this.ruleForm.RecordName,
                        conditionType:this.ruleForm.conditionType,
                        state:this.ruleForm.state,
                        note:this.ruleForm.note,
                        condition:{}
                    }
                    if(parm.conditionType==1){
                        parm.condition=[{
                            deviceCode:this.ruleForm.trigger.deviceCode,
                            property:this.ruleForm.trigger.property,
                            compare:this.ruleForm.trigger.compare,
                            value:this.ruleForm.trigger.value
                        }]
                    }else{
                        if(this.radioTime==1){
                            parm.condition=[{
                                type:this.radioTime,
                                date:new Date(this.ruleForm.assignDate).getTime()
                            }]
                        }else{
                            parm.condition=[{
                                type:this.radioTime,
                                time:Number(this.ruleForm.hour*3600+this.ruleForm.min*60+Number(this.ruleForm.second)),
                                week:this.ruleForm.weekList.sort()
                            }]
                        }
                    }
                    this.postNoJson('/ServicePlan/create',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '新建维保计划成功',
                                type: 'success'
                            });
                            let parm={
                                id:res.result,
                                companyId:this.companyId
                            }
                            this.get('/ServicePlan/get',parm).then((res)=>{
                                if(res.success){
                                    this.planList.unshift(res.result)
                                }
                            })
                        }else{
                            this.$message({
                                message: `新建维保计划失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                        this.$store.state.mask=false;
                        this.addPlanShow =false
                    })
                }
            })
        },
        //编辑维保计划
        updatePlan(){
            this.$refs.editPlan.validate((valid) => {
                if(valid){
                    let parm = {
                        id:this.nowObj.id,
                        companyId:this.companyId,
                        requestId:1,
                        name:this.ruleForm.RecordName,
                        conditionType:this.ruleForm.conditionType,
                        state:this.ruleForm.state,
                        note:this.ruleForm.note,
                        condition:{}
                    }
                    if(parm.conditionType==1){
                        parm.condition=[{
                            deviceCode:this.ruleForm.trigger.deviceCode,
                            property:this.ruleForm.trigger.property,
                            compare:this.ruleForm.trigger.compare,
                            value:this.ruleForm.trigger.value
                        }]
                    }else{
                        if(this.radioTime==1){
                            parm.condition=[{
                                type:this.radioTime,
                                date:new Date(this.ruleForm.assignDate).getTime()
                            }]
                        }else{
                            parm.condition=[{
                                type:this.radioTime,
                                time:Number(this.ruleForm.hour*3600+this.ruleForm.min*60+Number(this.ruleForm.second)),
                                week:this.ruleForm.weekList.sort()
                            }]
                        }
                    }
                    this.postNoJson('/ServicePlan/update',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '编辑维保计划成功',
                                type: 'success'
                            });
                            this.get('/ServicePlan/get',{id:parm.id,companyId:this.companyId}).then((res)=>{
                                if(res.success){
                                    this.planList[this.nowIndex]=res.result
                                }
                            })
                            this.$store.state.mask=false;
                            this.editPlanShow =false
                        }else{
                            this.$message({
                                message: `编辑维保计划失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        // 修改指定时间
        changeAssign(val){
            // console.log(val)
        },
        // 下拉框title
        getTitle(val,data,code){
            if(val&&data&&code){
                let result=data.filter(ele => ele[code] == val);
                if (result.length!=0) return result[0].name
            }
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                  this.$message({
                    message: `${res.message}`,
                    type: 'warning'
                  });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(12),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
    },
}
</script>
<style scoped>
    .list-box{
        position: absolute;
        top: 98px;
        left: 16px;
        right: 16px;
        bottom: 0;
        min-width: 1320px;
        width: calc(100% - 32px);
    }
    /* 头部标签 */
    .tabs-box{
        position: absolute;
        top: -40px;
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        float: left;
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    /* 背景盒子 */
    .bg{
        background-color: #fff;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right:0;
        padding: 34px 20px 0 20px;
    }
    /* 列表 */
    .scroll{
        overflow: auto;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        line-height: 44px;
        font-size: 14px;
        max-height: 83% !important;
        height: 83%;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 140px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .w-26{
        width: 26% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
        margin-bottom: 18px;
    }
    .m-t-38{
        margin-top: 38px;
    }
    .top-20{
        position: absolute;
        top: 20px;
    }
    /* 弹窗 */
    .dev-name-list{
        display: inline-block;
        width: 470px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        top: 10px;
    }
    .popup>div{
        position: fixed;
        top: -20px;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-289px;
        width: 578px;
        background-color: #fff;
        z-index: 999;
        padding-bottom: 30px;
        height: 285px;
        text-align: left;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 12px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 1px;
        top: 4px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .attribute{
        width: 127px;
        margin-right: 6px;
    }
    .popup-addRecord{
        width: 597px !important;
        height: 577px !important;
        top: -98px !important;
    }
    .note{
        height: 133px;
    }
    .h-113{
        height: 113px;
    }
    .m-t-15{
        margin-top: 15px;
    }
    .m-b-12{
        margin-bottom: 12px;
    }
    .state-p{
        line-height: 14px;
        height: 14px;
    }
    .option-box{
        line-height: 44px;
        border-radius: 5px;
        overflow: hidden;
    }
    .option-box-top{
        text-align: left;
        padding: 0 22px;
        font-size: 14px;
        background-color: #eeeeee;
    }
    .all-check{
        float: right;
    }
    .option-scorll-box{
        max-height: 430px;
        overflow: auto;
    }
    .popup-select-attribute{
        top: -98px !important;
        width: 597px !important;
        height: 628px !important;
    }
    .plan-state span{
        margin-right: 25px;
        cursor: pointer;
    }
    .w-100{
        margin:6px 0 0 0!important;
        width: 100% !important;
    }
    .dev-attr-box{
        margin-top: 18px;
    }
    .m-r-0{
        margin-right:0 !important ;
    }
    .m-t-0{
        margin-top: 0 !important;
    }
    .search-box{
        text-align: left;
        font-size: 15px;
        float: right;
    }
    .state-box{
        width: 120px;
        margin-right: 32px;
    }
    .time{
        margin-left: 12px;
        width: 220px;
        margin-right: 25px
    }
    .search{
        float: right;
        width: 75%;
        max-width: 388px;
        min-width: 160px;
        margin-right: 10px;
    }
    .w-25{
        width: 28%;
    }
    .w-20{
        width: 15%;
    }
    .w-76{
        width: 76%;
        margin-right: 11px;
    }
    .m-r-12{
        margin-right: 12px;
    }
    .m-t-0{
        margin-top: 0 !important;
    }
    .w-97{
        width: 97%;
    }
    .w-1090{
        width: 1090px;
    }
    .w-386{
        width: 386px;
    }
</style>
<style>
    #ServicePlan .enum .el-form-item__label,#ServicePlan .bool .el-form-item__label,#ServicePlan .range .el-form-item__label,#ServicePlan .w-100 .el-form-item__label{
        width: 100%;
        text-align: left;
    }
    #ServicePlan .range .el-input{
        width: 242px;
    }
    #ServicePlan .enum .el-input{
        width: 210px;
    }
    #ServicePlan .bool .el-input{
        width:482px;
        float: right;
    }
    #ServicePlan .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #ServicePlan .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #ServicePlan .popup .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #ServicePlan .remarks textarea{
        width: 100% !important;
        height: 76px !important;
        border: 1px solid #dedede !important;
        resize: none !important;
        padding:5px !important;
        box-sizing: border-box  !important;
        line-height: 20px !important;
        overflow: hidden !important;
    }
    #ServicePlan .remarks.note textarea{
        height: 133px !important;
    }
    #ServicePlan .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #ServicePlan .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #ServicePlan .attribute .el-input__icon,#ServicePlan .popup .el-input__icon{
        line-height: 34px !important;
    }
    .enum .el-form-item__error{
        padding-top: 0 !important;
    }
    #ServicePlan .checkbox-box .el-checkbox{
        width: 27% !important;
    }
    #ServicePlan  .option-scorll-box .el-checkbox{
        display: block;
        text-align: left;
        padding-left: 10px;
        margin-right: 0;
        border-bottom: 1px solid #e6e6e6;
    }
    #ServicePlan  .option-scorll-box .el-checkbox__input{
        position: absolute;
        left: 448px;
        top: 15px;
    }
    #ServicePlan .assignDate .el-input__prefix{
        position: absolute;
        left: 510px;
    }
    #ServicePlan .weekList .el-checkbox{
        margin-right: 25px;
    }
    #ServicePlan .el-form-item__content .weekList{
        line-height: 12px !important;
    }
    #ServicePlan .time .el-input__icon {
        position: relative;
        top: -3px;
    }
    #ServicePlan .time .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px 0 25px!important;
    }
    #ServicePlan .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #ServicePlan .popup .el-form-item.w-28{
        width: 24.2% !important;
        float: left;
        margin-right: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CompanyConsole/ServicePlan/ServicePlan.vue